import { useT } from "../../i18n";
import { NativeSelect } from "./FilterControls";

const SORTS = ["newest", "oldest", "updated", "price_asc", "price_desc", "year_desc", "year_asc", "mileage_asc", "mileage_desc", "make_az", "make_za"];

export const SortSelect = ({ value, onChange, id, scope }) => {
  const t = useT();
  const sorts = scope === "sold" ? ["sold_recent", ...SORTS] : SORTS;
  const first = sorts[0];
  return (
    <div className="flex items-center gap-3">
      <label htmlFor={id} className="sr-only">{t("filters.sort")}</label>
      <NativeSelect id={id} testId={`${id}-select`} value={value || first} onChange={(v) => onChange(v === first ? "" : v)} className="w-[12.5rem] max-w-full">
        {sorts.map((s) => <option key={s} value={s}>{t(`filters.sorts.${s}`)}</option>)}
      </NativeSelect>
    </div>
  );
};
